export enum DeviceOperatingSystem {
  iOS = 1,
  Android = 2,
}
